import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit';
import Restaurant from '../../../app/data/models/restaurant';
import api from '../../../app/api/api';
import { RootState } from '../../../app/store/configureStore';
import PageItem from '../../../app/data/models/common/pageItem';

export interface KitchenStaffRestaurantsState {
  restaurantsLoaded: boolean;
  restaurants: Restaurant[];
  status: string;
}

const restaurantsAdapter = createEntityAdapter<Restaurant>();

export const fetchKitchenStaffRestaurantListAsync = createAsyncThunk<
  PageItem<Restaurant>
>(
  'kitchenStaff/restaurants/fetchKitchenStaffRestaurantListAsync',
  async (_, thunkApi) => {
    try {
      return await api.KitchenStaffRestaurant.list();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      return thunkApi.rejectWithValue({ error: error.data });
    }
  }
);

export const fetchKitchenStaffRestaurantAsync = createAsyncThunk<
  Restaurant,
  string
>(
  'kitchenStaff/restaurants/fetchKitchenStaffRestaurantAsync',
  async (restaurantId, thunkApi) => {
    try {
      return await api.KitchenStaffRestaurant.details(restaurantId);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      return thunkApi.rejectWithValue({ error: error.data });
    }
  }
);

export const kitchenStaffRestaurantSlice = createSlice({
  name: 'restaurants',
  initialState:
    restaurantsAdapter.getInitialState<KitchenStaffRestaurantsState>({
      restaurantsLoaded: false,
      restaurants: [],
      status: 'idle',
    }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchKitchenStaffRestaurantListAsync.pending, (state) => {
      state.status = 'pendingFetchKitchenStaffRestaurantList';
    });
    builder.addCase(
      fetchKitchenStaffRestaurantListAsync.fulfilled,
      (state, action) => {
        restaurantsAdapter.setAll(state, action.payload.data);
        state.restaurantsLoaded = true;
        state.status = 'idle';
      }
    );
    builder.addCase(fetchKitchenStaffRestaurantListAsync.rejected, (state) => {
      state.status = 'idle';
    });
    builder.addCase(fetchKitchenStaffRestaurantAsync.pending, (state) => {
      state.status = 'pendingFetchKitchenStaffRestaurantList';
    });
    builder.addCase(
      fetchKitchenStaffRestaurantAsync.fulfilled,
      (state, action) => {
        restaurantsAdapter.upsertOne(state, action.payload);
        state.status = 'idle';
      }
    );
    builder.addCase(fetchKitchenStaffRestaurantAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});

export const kitchenStaffRestaurantSelectors = restaurantsAdapter.getSelectors(
  (state: RootState) => state.kitchenStaffRestaurants
);
